var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilesharing = function SvgFilesharing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.682 9.319-6.39 6.39a1 1 0 0 1-.707.293H7.998a1 1 0 0 1-1-1v-1.587c0-.266.104-.521.29-.71L14.32 5.51a3.886 3.886 0 0 1 5.526-.03l.072.071a3.947 3.947 0 0 1-.016 5.62c-2.359 2.31-5.59 5.525-7.441 7.372a5.002 5.002 0 0 1-3.532 1.46H5.997a3.001 3.001 0 0 1-3-3.002v-2.93c0-1.326.526-2.599 1.464-3.537l6.218-6.218"
  })));
};
export { SvgFilesharing as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNWNmZjMzZDc3Y2U4NDlkMDVjZDFhN2ZlNDZjZTgxZDAuc3ZnIjs=";